import axios from 'axios'

/**
 *
 * @param {string} workspaceId
 * @returns List of all details regarding home page
 */
export const getDashboardDetails = async (workspaceId) => {
  const response = await axios.get(`home?workspaceId=${workspaceId}`)
  return response
}

/**
 *
 * @param {string} workspaceId
 * @returns credits details
 */
export const getCreditsDetails = async (workspaceId = null) => {
  const response = await axios.get(
    `tenants/credit-usage?workspaceId=${workspaceId}`
  )
  return response
}

/**
 *
 * @returns welcome offer eligibility check
 */
export const getWelcomeOffer = async () => {
  const response = await axios.get(`plans/welcome-offer`)
  return response
}
